/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

// pf custom popup
class PfEntryPopup extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.closeBtn = this.querySelector(".close_btn");
    this.closeBtn.addEventListener("click", this.closePopup.bind(this));
    this.addEventListener("click", (e) => {
      if (e.target === this) {
        this.closePopup();
      }
    });

    this.showPopup();
  }
  closePopup() {
    this.classList.remove("active");
  }
  showPopup() {
    const showOneTime = this.getAttribute("one-time");
    const isShow = window.localStorage.getItem("pfEntryPopup");
    window.addEventListener("load", () => {
      if (showOneTime === "true") {
        if (isShow !== "true") {
          this.classList.add("active");
          window.localStorage.setItem("pfEntryPopup", "true");
        }
      } else {
        this.classList.add("active");
      }
    });
  }
}
customElements.define("pf-entry-popup", PfEntryPopup);


(function() {
  // Add custom code below this line

  $('.scroll-to-lead').on('click', () => {
    //$('body').scrollTo('[href="#lead-form"]');
    //$('[href="#lead-form"]').get(0).scrollIntoView({behavior: 'smooth'});
    $('html, body').animate({ scrollTop: $('[href="#lead-form"]').offset().top - 200}, "slow", "linear");
  })

  $(document).ready(function() {
      $('.sale_slider').slick({
      slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 3000,
        pauseOnHover: false,
        cssEase: 'linear',
        arrows: false,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
          
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 3000,
        pauseOnHover: false,
        cssEase: 'linear',
        arrows: false,
        variableWidth: true,
            }
          }
          ]
      });
  });
 
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
     
